import { Outlet } from 'react-router-dom';

const ContractPage = () => {
  return <Outlet />;
};

export default ContractPage;
